(() => {
  const initialize = (gallery) => {
    if (gallery.dataset.ryfInitialized) return;
    gallery.dataset.ryfInitialized = 'true';
    const media = Array.from(gallery.querySelectorAll('.ryf-001-gallery__stage > .ryf-001-gallery__media'));
    const buttons = Array.from(gallery.querySelectorAll('[data-ryf-media]'));
    const video = media[0];
    const pause = gallery.querySelector('.ryf-001-gallery__pause');
    const updatePlayback = () => {
      pause.textContent = video.paused ? gallery.dataset.playText : gallery.dataset.pauseText;
      pause.setAttribute('aria-label', video.paused ? gallery.dataset.playLabel : gallery.dataset.pauseLabel);
    };
    video.addEventListener('play', updatePlayback);
    video.addEventListener('pause', updatePlayback);

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const index = Number(button.dataset.ryfMedia);
        media.forEach((item, itemIndex) => { item.hidden = itemIndex !== index; });
        buttons.forEach((item, itemIndex) => {
          item.classList.toggle('is-active', itemIndex === index);
          item.setAttribute('aria-pressed', itemIndex === index ? 'true' : 'false');
        });
        pause.hidden = index !== 0;
        if (index === 0 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      });
    });

    pause.addEventListener('click', () => {
      if (video.paused) {
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    });

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      video.pause();
    }
    updatePlayback();
  };

  const initializeAll = () => document.querySelectorAll('.ryf-001-gallery').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
  else initializeAll();
  document.addEventListener('shopify:section:load', initializeAll);
})();
